import axios from "./axios";
import { STORE_URL, SEND_EMAIL_INVITATION, TRANSFER_CREDIT, GET_ATTENDANCE_LIST } from "./APILinks";

import { apiCreateKocekOutToken } from "./utils";

export const fetchStoreById = (id) => axios.get(STORE_URL + "/" + id);

export const fetchStores = (params) =>
  axios.get(STORE_URL, {
    params,
  });

/**
 * @param {object} store
 * @param {object} store.open_day
 * @param {string} store.is_available set '1' if available and '0' if unavailable
 * @returns {Promise<void>}
 * @example
 * {
 *   is_available: '1',
 *   open_day: {
 *     mon: {
 *       shifts: [
 *         { startTime: new Date().toISOString(), endTime: moment().toISOString() }
 *       ]
 *     }
 *   }
 * }
 */
export const createStore = async (store) => {
  return axios.post(STORE_URL, store);
};

/**
 * @param {object} store
 * @param {object} store.open_day
 * @param {string} store.is_available set '1' if available and '0' if unavailable
 * @returns {Promise<void>}
 * @example
 * {
 *   is_available: '1',
 *   open_day: {
 *     mon: {
 *       shifts: [
 *         { startTime: new Date().toISOString(), endTime: moment().toISOString() }
 *       ]
 *     }
 *   }
 * }
 */
export const updateStore = async (id, store) => {
  return axios.put(STORE_URL + "/" + id, store);
};

export const transferCredit = async (formData) => {
  try {
    return axios.post(TRANSFER_CREDIT, formData);
  } catch (e) {
    console.log(e);
  }
};

export const sendInvitationToStore = (email) => axios.post(SEND_EMAIL_INVITATION, { email });

export const fetchAttendance = async (merchantName, page = 1, pageSize = 20) => {
  try {
    const token = await apiCreateKocekOutToken();

    const filters = merchantName ? { staff_merchant_name: merchantName } : {}; 

    const response = await axios.get(GET_ATTENDANCE_LIST, {
      headers: {
        Authorization: `${token.data.token_type} ${token.data.access_token}`,
      },
      params: {
        filters: JSON.stringify(filters),
        page,
        pageSize,
      },
    });

    return response.data; 
  } catch (error) {
    console.error("Error fetching attendance:", error);
    throw error; 
  }
};
